import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
// action
import { getSetting, updateGameStatus, updateSetting } from "../../store/setting/action";
import {
    getBaishunGames,
    updateBaishunGameStatus,
} from "../../store/BaishunHistory/action";

const GameManagement = (props) => {
    const hasPermission = useSelector((state) => state.admin.admin.flag);

    const [gameCoin1, setGameCoin1] = useState(0);
    const [gameCoin2, setGameCoin2] = useState(0);
    const [gameCoin3, setGameCoin3] = useState(0);
    const [gameCoin4, setGameCoin4] = useState(0);
    const [gameCoin5, setGameCoin5] = useState(0);
    const [gameRules, setGameRules] = useState("");
    const [mongoId, setMongoId] = useState("");

    useEffect(() => {
        props.getSetting();
        props.getBaishunGames();
    }, []);

    const setting = useSelector((state) => state.setting.setting);
    const baishunGames = useSelector((state) => state.baishunHistory.games);

    useEffect(() => {
        if (setting) {
            setMongoId(setting._id);
            setGameRules(setting?.gameRule || "");
            if (setting?.gameCoin && setting.gameCoin.length > 0) {
                setGameCoin1(setting.gameCoin[0] ?? 0);
                setGameCoin2(setting.gameCoin[1] ?? 0);
                setGameCoin3(setting.gameCoin[2] ?? 0);
                setGameCoin4(setting.gameCoin[3] ?? 0);
                setGameCoin5(setting.gameCoin[4] ?? 0);
            }
        }
    }, [setting]);

    const handleGameToggle = (gameName) => {
        if (!setting._id) {
            return;
        }
        props.updateGameStatus(setting._id, gameName);
    };

    const handleSubmit = () => {
        if (!mongoId) return;

        const gameCoin = [gameCoin1, gameCoin2, gameCoin3, gameCoin4, gameCoin5];
        const data = {
            gameRule: gameRules,
            gameCoin,
        };
        props.updateSetting(mongoId, data);
    };

    const handleBaishunToggle = (game) => {
        props.updateBaishunGameStatus(game.gameId, !game.isEnabled);
    };

    return (
        <>
            <div className="page-title">
                <div className="row">
                    <div className="col-12 col-md-6 order-md-1 order-last">
                        <h3 className="mb-3 text-white">Game Management</h3>
                    </div>
                    <div className="col-12 col-md-6 order-md-2 order-first">
                        <nav
                            aria-label="breadcrumb"
                            className="breadcrumb-header float-start float-lg-end"
                        >
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/admin/dashboard" className="text-danger">
                                        Dashboard
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Game Management
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-12">
                    <div className="card">
                        <div className="card-header pb-0">
                            <h4 className="card-title">Game Maintenance</h4>
                        </div>
                        <div className="card-body">
                            <h5 className="card-title d-flex justify-content-between align-items-center mb-3">
                                VibeWheel Game
                                <label className="switch mb-0">
                                    <input
                                        type="checkbox"
                                        checked={setting?.activeGames?.vibeWheel || false}
                                        onChange={() => handleGameToggle("vibeWheel")}
                                        disabled={!hasPermission}
                                    />
                                    <span className="slider">
                                        <p
                                            style={{
                                                fontSize: 12,
                                                marginLeft: `${setting?.activeGames?.vibeWheel ? "7px" : "35px"}`,
                                                color: `${setting?.activeGames?.vibeWheel ? "#fff" : "#000"}`,
                                                marginTop: "6px",
                                            }}
                                        >
                                            {setting?.activeGames?.vibeWheel ? "Yes" : "No"}
                                        </p>
                                    </span>
                                </label>
                            </h5>

                            <h5 className="card-title d-flex justify-content-between align-items-center mb-3">
                                Teen Patti Game
                                <label className="switch mb-0">
                                    <input
                                        type="checkbox"
                                        checked={setting?.activeGames?.teenPatti || false}
                                        onChange={() => handleGameToggle("teenPatti")}
                                        disabled={!hasPermission}
                                    />
                                    <span className="slider">
                                        <p
                                            style={{
                                                fontSize: 12,
                                                marginLeft: `${setting?.activeGames?.teenPatti ? "7px" : "35px"}`,
                                                color: `${setting?.activeGames?.teenPatti ? "#fff" : "#000"}`,
                                                marginTop: "6px",
                                            }}
                                        >
                                            {setting?.activeGames?.teenPatti ? "Yes" : "No"}
                                        </p>
                                    </span>
                                </label>
                            </h5>

                            <h5 className="card-title d-flex justify-content-between align-items-center mb-0">
                                Diamond Rain Game
                                <label className="switch mb-0">
                                    <input
                                        type="checkbox"
                                        checked={setting?.activeGames?.diamondRain || false}
                                        onChange={() => handleGameToggle("diamondRain")}
                                        disabled={!hasPermission}
                                    />
                                    <span className="slider">
                                        <p
                                            style={{
                                                fontSize: 12,
                                                marginLeft: `${setting?.activeGames?.diamondRain ? "7px" : "35px"}`,
                                                color: `${setting?.activeGames?.diamondRain ? "#fff" : "#000"}`,
                                                marginTop: "6px",
                                            }}
                                        >
                                            {setting?.activeGames?.diamondRain ? "Yes" : "No"}
                                        </p>
                                    </span>
                                </label>
                            </h5>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-12">
                    <div className="card">
                        <div className="card-header pb-0">
                            <h4 className="card-title">BAISHUN Game Maintenance</h4>
                        </div>
                        <div className="card-body">
                            {baishunGames.length > 0 ? (
                                baishunGames.map((game, index) => (
                                    <h5
                                        key={game.gameId}
                                        className={`card-title d-flex justify-content-between align-items-center ${
                                            index === baishunGames.length - 1 ? "mb-0" : "mb-3"
                                        }`}
                                    >
                                        {game.name}
                                        <label className="switch mb-0">
                                            <input
                                                type="checkbox"
                                                checked={game.isEnabled !== false}
                                                onChange={() => handleBaishunToggle(game)}
                                                disabled={!hasPermission}
                                                aria-label={`${game.isEnabled ? "Disable" : "Enable"} ${game.name}`}
                                            />
                                            <span className="slider">
                                                <p
                                                    style={{
                                                        fontSize: 12,
                                                        marginLeft: `${game.isEnabled ? "7px" : "35px"}`,
                                                        color: `${game.isEnabled ? "#fff" : "#000"}`,
                                                        marginTop: "6px",
                                                    }}
                                                >
                                                    {game.isEnabled ? "Yes" : "No"}
                                                </p>
                                            </span>
                                        </label>
                                    </h5>
                                ))
                            ) : (
                                <p className="text-muted mb-0">No BAISHUN games available.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-md-6 col-12">
                    <div className="card">
                        <div className="card-header pb-0">
                            <h4 className="card-title">Teen Patti Settings</h4>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <form>
                                    <div className="mb-3">
                                        <label htmlFor="gameRules" className="form-label">
                                            Game Rules
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="gameRules"
                                            value={gameRules}
                                            onChange={(e) => setGameRules(e.target.value)}
                                        />
                                    </div>
                                    <div className="row d-flex justify-content-between">
                                        <p>Game Diamonds Setting</p>
                                        <div className="col-md-2">
                                            <div className="mb-3">
                                                <label htmlFor="diamond1" className="form-label">
                                                    Diamond 1
                                                </label>
                                                <input
                                                    min="0"
                                                    type="number"
                                                    className="form-control"
                                                    id="diamond1"
                                                    value={gameCoin1}
                                                    onChange={(e) => setGameCoin1(parseInt(e.target.value) || 0)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="mb-3">
                                                <label htmlFor="diamond2" className="form-label">
                                                    Diamond 2
                                                </label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    className="form-control"
                                                    id="diamond2"
                                                    value={gameCoin2}
                                                    onChange={(e) => setGameCoin2(parseInt(e.target.value) || 0)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="mb-3">
                                                <label htmlFor="diamond3" className="form-label">
                                                    Diamond 3
                                                </label>
                                                <input
                                                    min="0"
                                                    type="number"
                                                    className="form-control"
                                                    id="diamond3"
                                                    value={gameCoin3}
                                                    onChange={(e) => setGameCoin3(parseInt(e.target.value) || 0)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="mb-3">
                                                <label htmlFor="diamond4" className="form-label">
                                                    Diamond 4
                                                </label>
                                                <input
                                                    min="0"
                                                    type="number"
                                                    className="form-control"
                                                    id="diamond4"
                                                    value={gameCoin4}
                                                    onChange={(e) => setGameCoin4(parseInt(e.target.value) || 0)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="mb-3">
                                                <label htmlFor="diamond5" className="form-label">
                                                    Diamond 5
                                                </label>
                                                <input
                                                    min="0"
                                                    type="number"
                                                    className="form-control"
                                                    id="diamond5"
                                                    value={gameCoin5}
                                                    onChange={(e) => setGameCoin5(parseInt(e.target.value) || 0)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end">
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={handleSubmit}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default connect(null, {
    getSetting,
    updateGameStatus,
    updateSetting,
    getBaishunGames,
    updateBaishunGameStatus,
})(GameManagement);
